/** Mirrors backend profileCalculations for client-side previews */

export function maintenanceFromProfile(p: {
  weightKg: number;
  heightCm: number;
  age: number;
  sex?: string | null;
  activityLevel: string;
}): number {
  const w = p.weightKg;
  const h = p.heightCm;
  const age = p.age;
  const s = (p.sex ?? 'male').toLowerCase();
  let bmr: number;
  if (s === 'female') bmr = 447.593 + 9.247 * w + 3.098 * h - 4.33 * age;
  else bmr = 88.362 + 13.397 * w + 4.799 * h - 5.677 * age;

  const mult: Record<string, number> = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
    very_active: 1.9,
  };
  return Math.round(bmr * (mult[p.activityLevel] ?? 1.55));
}

export function proteinTargetG(weightKg: number, fitnessGoal: string): number {
  const g = fitnessGoal.toLowerCase();
  if (g === 'cut') return Math.round(weightKg * 2.0);
  if (g === 'bulk') return Math.round(weightKg * 1.8);
  return Math.round(weightKg * 1.6);
}

export function calorieTargetFromGoal(maintenance: number, fitnessGoal: string): number {
  const g = fitnessGoal.toLowerCase();
  if (g === 'cut') return Math.round(maintenance * 0.82);
  if (g === 'bulk') return Math.round(maintenance * 1.08);
  return maintenance;
}

export function computeNutritionTargets(input: {
  weightKg: number;
  heightCm: number;
  age: number;
  sex?: string | null;
  activityLevel: string;
  fitnessGoal: string;
}) {
  const maintenanceCalories = maintenanceFromProfile(input);
  const proteinTarget = proteinTargetG(input.weightKg, input.fitnessGoal);
  const calorieTarget = calorieTargetFromGoal(maintenanceCalories, input.fitnessGoal);
  return { maintenanceCalories, proteinTargetG: proteinTarget, calorieTarget };
}
